import { render, staticRenderFns } from "./InscriptionDetail.view.vue?vue&type=template&id=fd2ab324&scoped=true"
import script from "./InscriptionDetail.view.vue?vue&type=script&lang=js"
export * from "./InscriptionDetail.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2ab324",
  null
  
)

export default component.exports